import classNames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Loader } from '@wix/design-system';
import { PageModeContext } from 'providers/PageMode/PageMode.provider';
import s from './SubscriptionPage.scss';
import { RootStore, withInjectedRootStore } from 'providers';
import { observer } from 'mobx-react';
import { useHttpClientSiteLevel } from '@wix/premium-fed-sdk/@premium-essentials-adaptors';
import { useState } from 'react';
import { IHttpClient } from '@wix/http-client';

export interface SubscriptionSelectToCartButtonProps {
  onCycleSelect(httpClient: IHttpClient | null | undefined): void;
  className?: string;
  rootStore: RootStore;
}

export const SubscriptionSelectToCartButtonComp: React.FC<
  SubscriptionSelectToCartButtonProps
> = ({ onCycleSelect, className, rootStore }) => {
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const [shouldRedirectToCart, setShouldRedirectToCart] = React.useState(false);

  const { t } = useTranslation();

  const {
    appContext: { siteGuid },
  } = rootStore.appStore;

  const { httpClient, isLoading: isHttpClientLoading } = useHttpClientSiteLevel(
    {
      siteId: siteGuid,
    },
  );

  React.useEffect(() => {
    if (shouldRedirectToCart && !isHttpClientLoading) {
      onCycleSelect(httpClient);
    }
  }, [shouldRedirectToCart, isHttpClientLoading]);

  const handleButtonClick = () => {
    setIsButtonLoading(true);
    if (isHttpClientLoading) {
      setShouldRedirectToCart(true);
    } else {
      onCycleSelect(httpClient);
    }
  };

  return (
    <PageModeContext.Consumer>
      {({ theme }) => (
        <Button
          className={classNames(s.selectButton, theme, className)}
          size='large'
          dataHook='select-cycle'
          onClick={handleButtonClick}
          prefixIcon={
            isButtonLoading ? (
              <Box height='fit-content' margin='0'>
                <Loader size='tiny' color='white' />
              </Box>
            ) : undefined
          }
        >
          {t('premium-cart.continue-entry.point')}
        </Button>
      )}
    </PageModeContext.Consumer>
  );
};

export const SubscriptionSelectToCartButton = withInjectedRootStore(
  observer(SubscriptionSelectToCartButtonComp),
);
